import { RootState } from 'src/store/store';
import { License, LicensePeople, ReportingHistory } from 'src/types/licenses';

export const selectLicenseView = (state: RootState) => state.licenseView;

export const selectReportingHistory = (
  state: RootState
): ReportingHistory | null =>
  Array.isArray(state.licenseView.reportingHistory)
    ? null
    : state.licenseView.reportingHistory;
export const selectReportingHistoryInProgress = (state: RootState): boolean =>
  state.licenseView.isGetReportingHistoryInProgress;
export const selectReportingHistorySuccess = (state: RootState): boolean =>
  state.licenseView.isGetReportingHistorySuccess;
export const selectReportingHistoryErrorMsg = (state: RootState): string =>
  state.licenseView.reportingHistoryErrorMsg;

export const selectPropertyContacts = (
  state: RootState
): LicensePeople | null => state.licenseView.propertyContacts;
export const selectPropertyContactsInProgress = (state: RootState): boolean =>
  state.licenseView.isGetPropertyContactsInProgress;
export const selectPropertyContactsSuccess = (state: RootState): boolean =>
  state.licenseView.isGetPropertyContactsSuccess;
export const selectPropertyContactsErrorMsg = (state: RootState): string =>
  state.licenseView.propertyContactsErrorMsg;

export const selectLicense = (state: RootState): License | null =>
  state.licenseView.license;
export const selectLicenseInProgress = (state: RootState): boolean =>
  state.licenseView.licenseInProgress;
export const selectLicenseSuccess = (state: RootState): boolean =>
  state.licenseView.licenseSuccess;

export const selectPermitActionability = (state: RootState): object | null =>
  state.licenseView.permitActionability;
export const selectPermitActionabilityInProgress = (
  state: RootState
): boolean => state.licenseView.isGetPermitActionabilityInProgress;
export const selectPermitActionabilitySuccess = (state: RootState): boolean =>
  state.licenseView.isGetPermitActionabilitySuccess;
export const selectPermitActionabilityErrorMsg = (state: RootState): string =>
  state.licenseView.permitActionabilityErrorMsg;
